export default __webpack_public_path__ + "static/media/Auction.a76d6a73.svg";